/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFedora: {
  name: 'fedora';
  data: string;
} = {
  name: 'fedora',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m600.676 432.128.002.003c-13.798-77.964-58.429-86.439-127.126-97.233 8.954-48.286 21.316-107.002 5.109-139.577-20.739-41.691-63.748-38.144-90.896-23.309l52.469 28.744c-63.795-11.93-95.757-82.911-138.58-93.595-59.705-14.895-89.459 66.637-122.334 123.46-88.878-39.959-152.205-58.384-165.266 7.104-29.402 147.418 231.511 230.709 372.475 251.324l12.519-29.718 67.34 43.527c82.469 6.624 143.38-19.35 134.288-70.73z"/></svg>`,
};
